module.exports = __webpack_public_path__ + "left.26fc1bb4b52cb534be07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/left.svg
// module id = 1293
// module chunks = 2